import type { TrackingEventParams } from '~/types/tracking-events'

export function useTrackingEvents() {
  const { proxy: metaPixel } = useScriptMetaPixel()
  const { proxy: googleAnalytics } = useScriptGoogleAnalytics()

  const trackingEvents = (eventName: string, params: TrackingEventParams) => {
    const timestamp = new Date().toISOString()

    metaPixel.fbq('trackCustom', eventName, {
      ...params,
      timestamp,
    })

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    googleAnalytics.gtag('event', eventName, {
      ...params,
      userId: params.user_id,
      timestamp,
    })
  }

  return {
    trackingEvents,
  }
}
